import BaseModelAPI from '../BaseModelAPI';

export default class DocumentLocation extends BaseModelAPI {
	static entity = 'documentlocation';
	static entityName = 'documentlocation';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}